export const TabEnum = {
  NotSelected: -1,
  Hold: 0,
  Availability: 1,
  Load: 2,
};

export const PickListTabs = {
  StorageLocation: 1,
  TruckRoute: 2,
  OrderingSite: 3,
};

export const PrintSortOptions = {
  ItemCode: 1,
  ItemDescription: 2,
};

export const LoadAvailabilityGroupOptions = {
  OrderNo: 1,
  Vendor: 2,
  StorageLocation: 3,
  ItemGroup: 4,
  BidGroup: 5,
  AccountCategory: 6,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/WarehouseReports.js